// removed by extract-text-webpack-plugin
module.exports = {"disclaimerDoc":"src-components-Invest-components-___DocumentOption__disclaimerDoc___5fYXM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Invest/components/DocumentOption.css
// module id = 1223
// module chunks = 3